import { AutogenModelEdiCrossRefAllocationCode, AutogenRowEdiCrossRefAllocationCode } from "./autogen/AutogenModelEdiCrossRefAllocationCode";

export class ModelEdiCrossRefAllocationCode extends AutogenModelEdiCrossRefAllocationCode<RowEdiCrossRefAllocationCode> {
	constructor() {
		super(RowEdiCrossRefAllocationCode);
	}
}

export class RowEdiCrossRefAllocationCode extends AutogenRowEdiCrossRefAllocationCode {
}